import React, { useEffect, useState } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import './Zone.css'
import InputCustom from '../../../../components/elements/InputCustom';
import TextAreaCustom from '../../../../components/elements/TextAreaCustom';
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';
import { putZone } from '../../../../store/Actions/ActionZone';

function EditZone({ open, setOpen, editObj, id, zone_id, warehouse_id }) {
    const { dispatch, langLocal, navigate, mode } = AbstructVar()
    const [name, setName] = useState(editObj?.name)
    const { translate } = AbstructLang()
    const [symbol, setSymbol] = useState(editObj?.symbol)
    const [description, setDescription] = useState(editObj?.description)
    const [load, setLoad] = useState('')
    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(putZone(id, name, symbol, description, zone_id, warehouse_id,editObj?.warehouse_zone_type_id, setLoad));
    };
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: `pop_center ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className='div_pop_zone' >
                {/*<p>{warehouse_id}</p>
                <p>{zone_id}</p>*/}
                {console.log(editObj)}
                <h2 className='add_zone' >{translate('edit_zone')}</h2>
                <InputCustom
                    label='name'
                    iconType='pencil'
                    type='text'
                    onChange={(e) => setName(e.target.value)}
                    value={editObj?.name}
                />
                <InputCustom
                    label='symbol'
                    iconType='pencil'
                    type='text'
                    onChange={(e) => setSymbol(e.target.value)}
                    value={editObj?.symbol}
                />
                <TextAreaCustom
                    label='description'
                    onChange={(e) => setDescription(e.target.value)}
                    nameClass='textarea-general'
                    value={editObj?.description}
                />
                <br></br>
                <button className='btn_top_table' onClick={handleSubmit} >
                    {
                        load ? "Loading ..." :
                            translate('edit')
                    }
                </button>
            </div>
        </RModal>
    )
}

export default EditZone
